import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Show, SignInButton } from "@clerk/react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useApi, errMsg, fmtDate, API } from "@/lib/api";
import axios from "axios";

export const WeekendPass = ({ weekend, count, onUnlocked }) => {
  const api = useApi();
  const [pw, setPw] = useState(null);
  useEffect(() => { axios.get(`${API}/paywall`).then((r) => setPw(r.data)).catch(() => {}); }, []);

  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 space-y-3" data-testid="weekend-pass">
      <p className="flex items-center gap-2 font-display font-bold"><Lock className="w-4 h-4 text-amber-400" />{count ? `${count} selection(s) published` : "Tips published"}</p>
      <p className="text-sm text-slate-300">Unlock every tip for the weekend of {fmtDate(weekend)} (Sat & Sun) with a one-off weekend pass{pw ? ` — $${pw.price} ${pw.currency}` : ""}.</p>
      <Show when="signed-out">
        <SignInButton><button data-testid="pass-signin-button" className="w-full py-2.5 rounded-full bg-blue-600 hover:bg-blue-500 text-sm font-semibold">Sign in to buy a pass</button></SignInButton>
      </Show>
      <Show when="signed-in">
        {pw?.paypal_ready && pw.client_id ? (
          <div data-testid="paypal-buttons">
            <PayPalScriptProvider options={{ clientId: pw.client_id, currency: pw.currency, intent: "capture" }}>
              <PayPalButtons style={{ layout: "vertical", shape: "pill", label: "pay" }}
                createOrder={async () => (await api("post", "/paypal/orders", { weekend })).id}
                onApprove={async (d) => {
                  try { await api("post", `/paypal/orders/${d.orderID}/capture`); toast.success("Weekend pass unlocked — enjoy the tips!"); onUnlocked(); }
                  catch (e) { toast.error(errMsg(e)); }
                }}
                onError={() => toast.error("PayPal couldn't start the payment. Please try again.")} />
            </PayPalScriptProvider>
            {pw.mode !== "live" && <p className="text-[11px] text-amber-300">Test mode — use a PayPal sandbox account, no real money is charged.</p>}
          </div>
        ) : <p className="text-xs text-slate-400" data-testid="pass-unavailable">Payments aren't available right now.</p>}
      </Show>
    </div>
  );
};
